import { Button } from "../components/ui/button";
import { FaWhatsapp } from "react-icons/fa";
import { api, waShareUrl, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { useState } from "react";

export function WhatsappShareButton({ entityType, entityId, fallbackText, label = "Share on WhatsApp", className = "", testid }) {
  const [busy, setBusy] = useState(false);

  async function share() {
    setBusy(true);
    let text = fallbackText || "";
    try {
      const { data } = await api.post("/ai/whatsapp-summary",
        { entity_type: entityType, entity_id: entityId, style: "short" });
      text = data.text || fallbackText || "";
    } catch (err) {
      toast.warning("Sharing without AI summary", { description: formatApiError(err) });
    } finally {
      setBusy(false);
    }
    const url = waShareUrl(text);
    window.open(url, "_blank");
  }

  return (
    <Button onClick={share} disabled={busy} data-testid={testid || "wa-share"}
      className={`bg-[#25D366] hover:bg-[#1EBE55] text-white rounded-full ${className}`}>
      <FaWhatsapp className="mr-2" size={18} /> {busy ? "Preparing…" : label}
    </Button>
  );
}
